var _excluded = ["src", "alt"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { UserFilled } from '@gympass/yoga-icons';
import Avatar from './Avatar';
var AvatarCircle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var src = _ref.src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Avatar, _extends({}, props, {
    ref: ref,
    src: src,
    alt: alt,
    borderRadius: "circle",
    icon: !src ? UserFilled : undefined
  }));
});
AvatarCircle.propTypes = Avatar.propTypes;
AvatarCircle.defaultProps = Avatar.defaultProps;
AvatarCircle.displayName = 'Avatar.Circle';
export default AvatarCircle;